"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformProjectRequest = exports.transformProjectListResponse = exports.transformProjectResponse = exports.BilledStatus = exports.BillingMethod = exports.ProjectType = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
const Date_1 = require("./Date");
const ProjectGroup_1 = require("./ProjectGroup");
const Service_1 = require("./Service");
var ProjectType;
(function (ProjectType) {
    ProjectType["FixedPrice"] = "fixed_price";
    ProjectType["HourlyRate"] = "hourly_rate";
})(ProjectType = exports.ProjectType || (exports.ProjectType = {}));
var BillingMethod;
(function (BillingMethod) {
    BillingMethod["BusinessRate"] = "business_rate";
    BillingMethod["ProjectRate"] = "project_rate";
    BillingMethod["ServiceRate"] = "service_rate";
    BillingMethod["TeamMemberRate"] = "team_member_rate";
})(BillingMethod = exports.BillingMethod || (exports.BillingMethod = {}));
var BilledStatus;
(function (BilledStatus) {
    BilledStatus["Billed"] = "billed";
    BilledStatus["PartiallyBilled"] = "partially_billed";
    BilledStatus["Unbilled"] = "unbilled";
})(BilledStatus = exports.BilledStatus || (exports.BilledStatus = {}));
function transformProjectResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isProjectErrorResponse)(status, response)) {
        return (0, Error_1.transformProjectErrorResponse)(response);
    }
    const { project } = response;
    return transformProjectParsedResponse(project);
}
exports.transformProjectResponse = transformProjectResponse;
function transformProjectListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isProjectErrorResponse)(status, response)) {
        return (0, Error_1.transformProjectErrorResponse)(response);
    }
    const { projects, meta } = response;
    const { total, per_page, page, pages } = meta;
    return {
        projects: projects.map((project) => transformProjectParsedResponse(project)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformProjectListResponse = transformProjectListResponse;
function transformProjectParsedResponse(project) {
    return {
        id: project.id,
        title: project.title,
        description: project.description,
        dueDate: project.due_date && (0, Date_1.transformDateResponse)(project.due_date, Date_1.DateFormat['YYYY-MM-DD']),
        clientId: project.client_id,
        internal: project.internal,
        budget: project.budget,
        fixedPrice: project.fixed_price,
        rate: project.rate,
        billingMethod: project.billing_method,
        projectType: project.project_type,
        projectManagerId: project.project_manager_id,
        active: project.active,
        complete: project.complete,
        sample: project.sample,
        createdAt: (0, Date_1.transformDateResponse)(project.created_at, Date_1.DateFormat['YYYY-MM-DDThh:mm:ss']),
        updatedAt: (0, Date_1.transformDateResponse)(project.updated_at, Date_1.DateFormat['YYYY-MM-DDThh:mm:ss']),
        loggedDuration: project.logged_duration,
        services: project.services && project.services.map((service) => (0, Service_1.transformServiceParsedResponse)(service)),
        billedAmount: project.billed_amount,
        billedStatus: project.billed_status,
        retainerId: project.retainer_id,
        expenseMarkup: project.expense_markup,
        groupId: project.group_id,
        group: project.group && (0, ProjectGroup_1.transformProjectGroupParsedResponse)(project.group),
    };
}
function transformProjectRequest(project) {
    return JSON.stringify({
        project: {
            id: project.id,
            title: project.title,
            description: project.description,
            due_date: project.dueDate,
            client_id: project.clientId,
            internal: project.internal,
            budget: project.budget,
            fixed_price: project.fixedPrice,
            rate: project.rate,
            billing_method: project.billingMethod,
            project_type: project.projectType,
            project_manager_id: project.projectManagerId,
            active: project.active,
            complete: project.complete,
            sample: project.sample,
            logged_duration: project.loggedDuration,
            billed_amount: project.billedAmount,
            billed_status: project.billedStatus,
            retainer_id: project.retainerId,
            expense_markup: project.expenseMarkup,
        },
    });
}
exports.transformProjectRequest = transformProjectRequest;
//# sourceMappingURL=Project.js.map